import { render, staticRenderFns } from "./Template_13.vue?vue&type=template&id=e8b118ca&scoped=true"
import script from "./Template_13.vue?vue&type=script&lang=js"
export * from "./Template_13.vue?vue&type=script&lang=js"
import style0 from "./Template_13.vue?vue&type=style&index=0&id=e8b118ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b118ca",
  null
  
)

export default component.exports